var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_234_8102)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2857 3.42859V3.42859H5.14285C4.88606 3.42859 4.64279 3.54373 4.47999 3.74232C4.31718 3.94091 4.252 4.20203 4.30236 4.45384L6.01664 13.0253C6.09677 13.4259 6.44856 13.7143 6.85714 13.7143H20.8753C21.2789 13.7181 21.6707 13.5779 21.9804 13.3188C22.2868 13.0624 22.4928 12.7062 22.5624 12.3132L23.9654 5.4693C23.9666 5.46337 23.9678 5.45742 23.9689 5.45146C24.014 5.20482 24.0045 4.95129 23.941 4.70873C23.8775 4.46618 23.7615 4.2405 23.6014 4.04762C23.4412 3.85473 23.2406 3.69933 23.0138 3.59238C22.7871 3.48543 22.5396 3.42952 22.2889 3.4286L22.2857 3.42859ZM20.8769 12H7.55983L6.1884 5.14288H22.2824L20.8803 11.9822C20.8791 11.9881 20.8779 11.9941 20.8769 12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58286 8.97322e-09C3.978 -4.0403e-05 4.36101 0.13642 4.66711 0.386295C4.96607 0.630344 5.17372 0.967944 5.25691 1.34424L5.97192 4.06809C6.09211 4.52596 5.81836 4.99458 5.36049 5.11477C4.90261 5.23496 4.434 4.96122 4.31381 4.50334L3.59381 1.76048C3.58979 1.74519 3.5862 1.72978 3.58304 1.71429H0.857147C0.38376 1.71429 3.8147e-06 1.33053 3.8147e-06 0.857143C3.8147e-06 0.383756 0.38376 8.97322e-09 0.857147 8.97322e-09H3.58286C3.58292 8.97322e-09 3.5828 8.97322e-09 3.58286 8.97322e-09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68904 12.0167C6.22484 12.1095 5.9238 12.5611 6.01664 13.0253L6.73664 16.6253L6.73731 16.6286C6.81635 17.0158 7.02675 17.3638 7.33289 17.6137C7.63899 17.8636 8.022 18.0001 8.41714 18C8.41719 18 8.41725 18 8.41731 18H18.8571C19.3305 18 19.7143 17.6163 19.7143 17.1429C19.7143 16.6695 19.3305 16.2858 18.8571 16.2858H8.41714L8.41696 16.2858L7.69763 12.6891C7.6048 12.2249 7.15323 11.9238 6.68904 12.0167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7143 22.2857C19.7143 21.3389 18.9468 20.5714 18 20.5714C17.0532 20.5714 16.2857 21.3389 16.2857 22.2857C16.2857 23.2325 17.0532 24 18 24C18.9468 24 19.7143 23.2325 19.7143 22.2857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1429 22.2857C11.1429 21.3389 10.3753 20.5714 9.42857 20.5714C8.48179 20.5714 7.71428 21.3389 7.71428 22.2857C7.71428 23.2325 8.48179 24 9.42857 24C10.3753 24 11.1429 23.2325 11.1429 22.2857Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_8102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.b57a74f54e87225efc87e63d9c542193.svg";
export { ForwardRef as ReactComponent };